/**
 * Checks if the dev features button should be shown depending on the environment and flags.
 * For non-prod environments, it is always shown.
 * For prod environment, it is only shown for internal users if at least one of the dev, alpha or beta modes are enabled.
 * @returns true if the button should be shown
 */
export function shouldShowDevFeaturesButton({
  isProduction,
  isInternalUser,
  isDevModeEnabled,
  isAlphaTestingEnabled,
  isBetaTestingEnabled
}) {
  // Always show in any non-prod environments
  if (!isProduction) {
    return true;
  }

  // For prod environment, only show for internal users
  if (!isInternalUser) {
    return false;
  }

  // Do not show if at least one of dev, alpha or beta modes are not enabled for prod internal users
  if (!(isDevModeEnabled || isAlphaTestingEnabled || isBetaTestingEnabled)) {
    return false;
  }
  return true;
}

/** Type guard function for tool toggle items */
export function isToolToggleItem(item) {
  return "controlType" in item && item.controlType === "toggle";
}

/** Type guard function for tool button items */
export function isToolButtonItem(item) {
  return "controlType" in item && item.controlType === "button";
}

/** Type guard function for theme mode toggle items */
export function isToolThemeModeItem(item) {
  return "controlType" in item && item.controlType === "themeMode";
}